import ApplicationAdapter from 'garaje/adapters/application';
import config from 'garaje/config/environment';

export default class MultiTenancyAdapter extends ApplicationAdapter {
  host = config.apiHost;
  namespace = 'a/multi-tenancy/api/v1';
}
